import { render } from "./NewEmployee.vue?vue&type=template&id=3e870427&scoped=true"
import script from "./NewEmployee.vue?vue&type=script&lang=js"
export * from "./NewEmployee.vue?vue&type=script&lang=js"

import "./NewEmployee.vue?vue&type=style&index=0&id=3e870427&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e870427"]])

export default __exports__